import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import ManageHotelHome from "../views/ManageHotelHome";
import ManageHotelRevenueWithdrawals from "../views/ManageHotelRevenueWithdrawals";
import ManageHotelRoomOrders from "../views/ManageHotelRoomOrders";
import ManageHotelAllRooms from "../views/ManageHotelAllRooms";
import ManageHotelAllReport from "../views/ManageHotelReport";

export default function ManageHotel({ hotelId }) {

	const appContext = useContext(AppContext);

	const [ view, setView ] = useState(null);

	async function init() {
		//run initializations here
	}

	function getView() {
		if(
			appContext.navSubItem &&
			!appContext.navExtraItem &&
			!appContext.navMoreItem
		) {
			return <ManageHotelHome hotelId={hotelId} />
		} else if(
			appContext.navSubItem &&
			appContext.navExtraItem === 'revenue_withdrawals' &&
			!appContext.navMoreItem
		) {
			return <ManageHotelRevenueWithdrawals hotelId={hotelId} />
		} else if(
			appContext.navSubItem &&
			appContext.navExtraItem === 'room_orders' &&
			!appContext.navMoreItem
		) {
			return <ManageHotelRoomOrders hotelId={hotelId} />
		} else if(
			appContext.navSubItem &&
			appContext.navExtraItem === 'all_rooms' &&
			!appContext.navMoreItem
		) {
			return <ManageHotelAllRooms hotelId={hotelId} />
		} else if(
			appContext.navSubItem &&
			appContext.navExtraItem === 'report' &&
			!appContext.navMoreItem
		) {
			return <ManageHotelAllReport hotelId={hotelId} />
		} 

		return null;
	}

	useEffect(() => {
		init();
	}, [ ])

	useEffect(() => {
		const _view = getView();
		if(_view) {
			setView(_view);
		}
	}, [ appContext.navSubItem, appContext.navExtraItem, appContext.navMoreItem ])

	//return desired view
	return view;
}